import React from 'react'

export function Intro() {
  return (
    <article>
      <h2>
        The Internet Computer eliminates the biggest obstacles facing
        entrepreneurs, enabling them to easily kick-start new ventures that
        quickly grow.
      </h2>
      <section>
        <h3>
          Case Study: Building an Open <br />
          Internet Service.
        </h3>
        <div className="article-row">
          <p>
            The Internet Computer is a next-generation computing platform that
            makes it possible to create digital businesses with maximum
            efficiency and low overhead, giving entrepreneurs powerful new ways
            to fulfill their three main needs:
            <ol>
              <li>Traction - “How do I attract customers, users, adoption?”</li>
              <li>
                Scaling - “How do I grow my app as painlessly as possible?”
              </li>
              <li>
                Financing - “How do I raise funds to continue development?”
              </li>
            </ol>
            To demonstrate this, here’s how building an autonomous variety of
            software called an open internet service on the Internet Computer
            offers uncommon advantages.
          </p>
        </div>
      </section>
    </article>
  )
}
